import {
    Table,
    Thead,
    Tbody,
    Th,
    Tr,
    Td,
    Spacer,
    FormCheckbox,
    Text,
    Ellipsis,
    HighlightedText,
} from "@holta/ui";
import React from "react";
import styled from "styled-components";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Link } from "raviger";
import { fns, libTypes } from "@holta/lib";
import { useSuppliersContext } from "../context";
import { useFilteredSuppliers } from "../../../hooks/useFilteredSuppliers";
import {handleSupplierTableHeadingClick} from "../../../actions/ui";
import { useStore } from "../../../config/store";
import { SortHighlight } from "../../../components/SortHighlight";
interface Props {
    
}

const Row = ({style, index, data} : {style:React.CSSProperties, index: number, data : {suppliers: libTypes.Supplier[], highlightVal : string}}) => {
    const {suppliers, highlightVal} = data;
    return (
        <Link href={"suppliers/" + suppliers[index].id} key={suppliers[index].id}>
            <Tr style={style} hasHover>
                <Td colspan={5}>
                    <Text size="m"><HighlightedText text={suppliers[index].name} highlight={highlightVal}/></Text>
                </Td>
                <Td colspan={1}>
                    <Text size="m">{fns.shared.formatDate(suppliers[index].dateCreated)}</Text>
                </Td>
            </Tr>
        </Link>
    )
};

export const SuppliersTable: React.FC<Props> = () => {

    const suppliers = useFilteredSuppliers();
    const ui = useStore(store => store.ui)
    const highlightVal = useStore(store => store.ui.suppliers.searchFilter)

    return (
        <Spacer
            xs={[0, 2, 2, 2]}
            style={{ flex: 1, display: "flex", flexDirection: "column", height: "100%" }}
        >
            <Table cols={6}>
                <Thead>
                    <Tr>
                        <Th colspan={5} onClick={() => {handleSupplierTableHeadingClick('name');}}>
                            <SortHighlight direction={ui.suppliers.sortDirection} thisField="name" uiField={ui.suppliers.sortField}>Name</SortHighlight>
                        </Th>

                        <Th colspan={1} onClick={() => handleSupplierTableHeadingClick('dateCreated')}>
                            <SortHighlight direction={ui.suppliers.sortDirection} thisField="dateCreated" uiField={ui.suppliers.sortField}>Date Created</SortHighlight>
                        </Th>
                    </Tr>
                </Thead>
                <Tbody style={{ flex: 1 }}>
                    <AutoSizer>
                        {({ height, width }: { height: number; width: number }) => (
                            <List height={height - 2} itemCount={suppliers.length} itemSize={46} width={width - 1} overscanCount={30} itemData={{suppliers, highlightVal}}>
                                {Row}
                            </List>
                        )}
                    </AutoSizer>
                </Tbody>
            </Table>
        </Spacer>
    );
};
